import { Alert } from '@fe-toolkit/web-components/ssr'
import styled from 'styled-components'

// This ensures the large margins on medium+ screen size Alert don't show up
// when the Alert is placed in a narrow container like the PlanCard,
// so that we can use the functionality of the Alert but not have it look odd in that context.
const AdaptiveAlert = styled(Alert)`
  container-type: inline-size;
  @container (width < 400px) {
    > div {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

export default AdaptiveAlert
